const SAFE_STATUS = [
  [/document|uploaded file/, 'Checking your documents.'],
  [/research|search|source|public_url/, 'Checking reliable sources.'],
  [/download|sandbox|file|deliverable/, 'Preparing your requested file.'],
  [/integration|connected|composio/, 'Checking your connected services.'],
]

export function safeVoiceStatus(event) {
  if (event?.type !== 'tool_result' || event.tool !== 'work_status') return null
  const tasks = Array.isArray(event.payload?.tasks) ? event.payload.tasks : []
  const active = tasks.find((task) => task?.status === 'in_progress')
  if (!active) return null
  const safeProjection = `${active.kind ?? ''} ${active.title ?? ''}`.toLowerCase()
  return SAFE_STATUS.find(([pattern]) => pattern.test(safeProjection))?.[1] ?? null
}
